import React from 'react';
import classnames from 'classnames';
import { withProps } from 'recompose';

import { Button } from 'components/core/Button';
import { Overlay } from 'components/core/GoogleMap';

export const enhance = withProps(
	({ facility, onClick, selected }) => ({
		className: classnames('facility-marker', { selected }),
		location: facility.location,
		label: (
			<Button
				className="facility-marker-button"
				segmentLabel="facility pin"
				onClick={onClick}
			>
				<span className="facility-marker-label">
					{facility.position}
				</span>
			</Button>
		)
	})
);

export default enhance(Overlay);
